/**
 * created by li si yi
 * 基础数据-水印管理
 */
import React, {Component} from 'react';
import {Button, message, Pagination, Input, Modal, Form, Select, Popconfirm, Upload, Icon} from "antd";
import BaseComponent from "../../../base/BaseComponent";
import BaseTable from "../../components/baseTable/BaseTable";
import {HEADER_HEIGHT} from "../../../constants";
import {Scrollbars} from "react-custom-scrollbars";
import UploadWall from "../../../components/upload/UploadWall";
import ChunkUpload from "../../../components/upload/ChunkUpload";
import {ATTCHMENT_TYPE, PIC_TYPE, PIC_TYPE_ORIGINAL} from "../../../constants";

const {Option} = Select;
export default class WatermarkManage extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            tabBarList: [ // 选项卡数据
                {
                    key: '0',
                    name: '冻结记录',
                }
            ],
            params: {},
            count: 0,
            positionValue: 'LOWER_RIGHT',// 默认位置
            saveParams: {// 水印保存
                "path": "",
                "percentage": "",
                "position": "LOWER_RIGHT",
                "status": 0
            },
            columns: [
                {
                    dataIndex: 'defaultValue',
                    key: 'defaultValue',
                    width: 80,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <div>{record.status === 1 ? "默认" : ""}</div>
                        )
                    }
                },
                {
                    title: '水印',
                    dataIndex: 'path',
                    key: 'path',
                    width: 400,
                    ellipsis: true,
                    render: (text, record) => {
                        return (
                            <img style={{width: 100, height: 70, objectFit: 'cover'}}
                                 src={record.path ? record.path : ""}/>
                        )
                    }
                },
                {
                    title: '占比',
                    dataIndex: 'percentage',
                    key: 'percentage',
                    width: 200,
                    ellipsis: true,
                    render: (text) => {
                        return (
                            <div>{text || text === 0 ? text : ''}</div>
                        )
                    }
                },
                {
                    title: '位置',
                    dataIndex: 'position',
                    key: 'position',
                    ellipsis: true,
                    render: (text) => {
                        let positionTitle;
                        switch (text) {
                            case 'UPPER_LEFT':
                                positionTitle = '左上';
                                break;
                            case 'UPPER':
                                positionTitle = '正上';
                                break;
                            case 'UPPER_RIGHT':
                                positionTitle = '右上';
                                break;
                            case 'LEFT':
                                positionTitle = '正左';
                                break;
                            case 'MIDDLE':
                                positionTitle = '正中';
                                break;
                            case 'RIGHT':
                                positionTitle = '正右';
                                break;
                            case 'LOWER_LEFT':
                                positionTitle = '左下';
                                break;
                            case 'LOWER':
                                positionTitle = '正下';
                                break;
                            case 'LOWER_RIGHT':
                                positionTitle = '右下';
                                break;
                        }
                        return (
                            <span>{positionTitle}</span>
                        )
                    }
                },
                {
                    title: '操作',
                    dataIndex: 'operation',
                    key: 'operation',
                    render: (text, record) => {
                        let that = this;
                        return (
                            <div>
                                <Button type={record.status === 1 ? 'primary' : ''} style={{marginRight: 10}}
                                        onClick={() => {// type={'primary'}
                                            that.setWatermark(record);
                                        }}>设为水印</Button>
                                <Button style={{marginRight: 10}} onClick={() => {
                                    that.edit(record);
                                    this.state.isAdd = false;
                                }}>设置位置</Button>
                                {/*{*/}
                                {/*    record.status === 1 ? null :*/}
                                {/*        <Popconfirm title="确定要删除吗？"*/}
                                {/*                    onConfirm={() => {*/}
                                {/*                        that.delData(record)*/}
                                {/*                    }}*/}
                                {/*                    okText="确定"*/}
                                {/*                    cancelText="取消">*/}
                                {/*            <Button>删除</Button>*/}
                                {/*        </Popconfirm>*/}
                                {/*}*/}
                                <Popconfirm title="确定要删除吗？"
                                            onConfirm={() => {
                                                that.delData(record)
                                            }}
                                            okText="确定"
                                            cancelText="取消">
                                    <Button>删除</Button>
                                </Popconfirm>
                            </div>
                        )
                    }
                },
            ],
            dataSource: [],
            visible: false,
            rowSelection: {
                onChange: (selectedRowKeys, selectedRows) => {
                    // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                    this.state.batchDelData = selectedRows;
                    this.setState({selectedRows: []})
                },
                getCheckboxProps: record => ({
                    disabled: record.name === 'Disabled User',
                    name: record.name,
                }),
            },
            batchDelData: [],
            currentClick: 0,
            positions: [
                {
                    title: "左上",
                    positionKey: 'UPPER_LEFT',
                },
                {
                    title: "正上",
                    positionKey: 'UPPER',
                },
                {
                    title: "右上",
                    positionKey: 'UPPER_RIGHT',
                },
                {
                    title: "正左",
                    positionKey: 'LEFT',
                },
                {
                    title: "正中",
                    positionKey: 'MIDDLE',
                },
                {
                    title: "正右",
                    positionKey: 'RIGHT',
                },
                {
                    title: "左下",
                    positionKey: 'LOWER_LEFT',
                },
                {
                    title: "右下",
                    positionKey: 'LOWER_RIGHT',
                },
                {
                    title: "正下",
                    positionKey: 'LOWER',
                },
            ],
            isAdd: false,
        };
    }

    componentWillMount() {
        // 去掉webp
        let spliceNum = PIC_TYPE_ORIGINAL.splice(5, 2);
        this.state.newPicType = PIC_TYPE_ORIGINAL;
    }

    componentDidMount() {
        this.getDataSource();
    }

    componentWillUnmount() {
    }


    render() {
        return (
            <div className="card-container" style={{margin: '15px', maxHeight: "calc(100vh - 100px)"}}>
                {/*列表内容*/}
                {this.renderTable()}
            </div>
        )
    }

    // 头部
    renderHeader = () => {
        return (
            <div style={{display: 'flex', justifyContent: 'space-between', width: '100%', marginBottom: 24}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    <Button type="primary" style={{marginRight: 10}} onClick={() => {
                        this.showModal();
                    }}>增加logo水印</Button>
                </div>
            </div>
        )
    };
    // 水印列表
    renderTable = () => {
        let {params} = this.state;
        let tableHeight = window.innerHeight - HEADER_HEIGHT  - 20 - 77 - 15 - 15;
        return (
            <div style={{
                backgroundColor: '#fff',
                borderRadius: '5px',
                width: '100%',
                // height: "calc(100vh - 100px)"
                maxHeight: "calc(100vh - 100px)",
            }}>
                <div style={{padding: '0 32px 24px', width: '100%', paddingTop: 24}}>
                    {/*头部*/}
                    {this.renderHeader()}
                    <Scrollbars autoHeight autoHeightMax={tableHeight}>
                        <BaseTable rowKey="_id"
                                   dataSource={this.state.dataSource}// rowSelection={this.state.rowSelection}
                                   columns={this.state.columns}
                                   pagination={false}/>
                    </Scrollbars>
                </div>
                {/*分页*/}
                {/*{this.renderPagination()}*/}
                {/*新增*/}
                {this.renderModal()}
            </div>
        )
    };
    //弹窗
    renderModal = () => {
        let {newPicType} = this.state;
        const accept = newPicType.map(item => "." + item).join(',');
        return (
            <Modal title={this.state.isAdd ? '添加水印' : '设置位置'}
                   width={this.state.isAdd ? 820 : 420}
                   maskClosable={false}
                   centered={true}
                   style={{height: 386}}
                   visible={this.state.visible}
                   onOk={this.handleOk}
                   onCancel={this.handleCancel}>
                {
                    this.state.currentClick === 0 ?
                        <UploadWall
                            accept={accept}
                            multiple={false}
                            action="/storage/uploadFile"
                            style={{
                                padding: 'unset',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                            customRequest={new ChunkUpload({
                                checkFileURL: "/storage/checkFile",
                                checkChunkURL: "/storage/checkChunk",
                                uploadChunkURL: "/storage/uploadChunk",
                                chunkUploadOverURL: "/storage/chunkIsUploadOver",
                                mergeChunksURL: "/storage/mergeChunk"
                            }).start}
                            uploadBtnName={"点击上传"}
                            beforeUpload={this.beforeUpload}
                            onChange={this.onChange}
                            onRemove={this.handleRemove}
                            imageUrl={this.state.saveParams.path}
                        /> : null
                }
                <div>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
                        <div style={{
                            width: this.state.isAdd ? '10%' : '24%',
                            textAlign: 'end',
                            marginRight: 5
                        }}><strong style={{color: "red",marginRight: "1px"}}>*</strong>水印占比<span style={{ marginRight: '2px'}}>:</span>
                        </div>
                        <Input placeholder={'请输入水印占比（1-100）'} addonAfter="%" value={this.state.saveParams.percentage} onChange={(e) => {
                            let num = e.target.value;
                            let value = num.replace(/[^\d]+/g, '');
                            this.setState({
                                saveParams: {
                                    ...this.state.saveParams,
                                    percentage: value,
                                }
                            })
                        }}/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <span style={{
                            width: this.state.isAdd ? '10%' : '24%',
                            textAlign: 'end',
                            marginRight: 5
                        }}>位置 <span style={{ marginRight: '2px'}}>:</span></span>
                        <Select value={this.state.isAdd ? this.state.positionValue : this.state.saveParams.position}
                                style={{width: '100%'}} onSelect={(e) => {
                            // console.log(e);
                            this.setState({
                                positionValue: e,
                                saveParams: {
                                    ...this.state.saveParams,
                                    position: e
                                }
                            })
                        }}>
                            {
                                this.state.positions.map((item, index) => {
                                    return (
                                        <Option value={item.positionKey} key={index}>{item.title}</Option>
                                    )
                                })
                            }
                        </Select>
                    </div>
                </div>
            </Modal>
        )
    };

    showModal = () => {
        this.setState({
            visible: true,
            currentClick: 0,
            isAdd: true,
        }, () => {
            if (this.state.currentClick === 0) {
                this.setState({
                    positionValue: 'LOWER_RIGHT',
                    saveParams: {
                        ...this.state.saveParams,
                        percentage: "",
                        position: 'LOWER_RIGHT',
                        path: ''
                    },
                });
            }
        })
    };
    // 保存
    handleOk = e => {
        message.destroy();
        let {saveParams, currentClick} = this.state;
        if (!saveParams.percentage) {
            message.error('请输入水印占比!');
            return false
        }
        if (saveParams.percentage <= 0) {
            saveParams.percentage = 1
        }
        if (saveParams.percentage > 100) {
            saveParams.percentage = 100
        }
        if (currentClick === 0) {
            if (!saveParams.path) {
                message.error('请选择水印!');
                return false
            }
            this.addSave(saveParams);
        } else if (currentClick === 1) {
            this.editData(saveParams);
        }
        this.setState({
            visible: false,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    //上传图片
    uploadImg(file) {
        // console.log('file--------------------------------', file.response.data.path);
        // if (!file.response && !file.response.data && !file.response.data.md5) {
        //     return
        // }
        this.setState({
            saveParams: {
                ...this.state.saveParams,
                path: file.response && file.response.data && file.response.data.path ? file.response.data.path : file.response.path
            }
        })
    }

    // 上传图片
    onChange = (info) => {
        window.loading.show(true);
        if (info.file.status === 'done') {
            window.loading.hide();
            this.uploadImg(info.file);
        }
        info.file = info.fileList.map(item => {
            // 取决于需要什么数据填入fileList
            if (item.uid === info.file.uid) {
                if (info.file.response && info.file.response.data) {
                    //分片上传是走的自己封装的接口 所以返回值只有data
                    //直接上传走的是antd的接口，所以返回值还有一个data属性包裹着的。这里主要是兼容两种返回值
                    info.file.response = {...info.file.response.data, ...info.file.response};
                }
                item.uid = info.file.uid;
                item.ext = info.file.response && info.file.response.suffix;
                item.url = info.file.response && info.file.response.path;
                item.name = info.file.response && info.file.response.name;
                item.md5 = info.file.response && info.file.response.md5;
                // item.type = "picture";
                item.isChunk = true;
                item.status = info.file.status;
            }
            return item;
        });
        this.setState({
            fileList: info.fileList,
        })
    };
    // 分页
    // renderPagination = () => {
    //     let {params, count} = this.state;
    //     let {start, size} = params;
    //     return (
    //         <div className={'pagination'} style={{}}>
    //             <div style={{padding: "0 10px 0"}}>共{count}条数据</div>
    //             <Pagination
    //                 showSizeChanger
    //                 current={start}
    //                 pageSize={size}
    //                 total={count}
    //                 showQuickJumper={true}
    //                 onChange={this.pageChange}
    //                 onShowSizeChange={this.pageChange}
    //             />
    //         </div>
    //     )
    // };

    // 获取选项卡内容数据
    getDataSource() {
        this.request({
            url: '/storage/watermark/list',
            callBack: (res) => {
                // console.log(res, '-----------------');
                let dataSource = [];
                // let count = 0;
                if (res) {
                    dataSource = res;
                    // count = res;
                }
                this.setState({dataSource});
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    // 设置水印
    setWatermark(record) {
        message.destroy();
        let params = {id: record._id};
        this.request({
            url: '/storage/watermark/set',
            method: 'post',
            contentType: 'json',
            body: params,
            callBack: (res) => {
                if (res) {
                    message.success('设置成功');
                    this.getDataSource();
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    // 分页改变
    pageChange = (start, size) => {
        let {params} = this.state;
        // 获取当前tab参数
        params.start = start;
        params.size = size;
        this.getDataSource();
    };
    // 新增保存
    addSave = (saveParams) => {
        this.request({
            url: '/storage/watermark/add',
            body: saveParams,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    message.success('添加成功');
                    this.getDataSource();
                } else {
                    message.error("添加失败！");
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            }
        });
    };

    //删除
    delData(record) {
        message.destroy();
        let params = {id: record._id};
        this.request({
            url: '/storage/watermark/delete',
            body: params,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    this.getDataSource();
                    message.success('删除成功')
                }
            }
        })
    };

    //修改水印参数
    edit(record) {
        this.state.currentClick = 1;
        this.setState({
            visible: true,
            currentClick: 1,
            saveParams: {
                ...this.state.saveParams,
                id: record._id,
                "percentage": parseInt(record.percentage),
                "position": record.position,
            }
        });
    }

    // 修改水印参数
    editData(saveParams) {
        this.request({
            url: '/storage/watermark/update',
            body: saveParams,
            method: 'post',
            contentType: 'json',
            callBack: (res) => {
                if (res) {
                    message.success('修改成功');
                    this.getDataSource();
                }
            }
        })
    }

    // 上传之前
    // beforeUpload = file => {
    //     const isJpgOrPng = file.type === "application/vnd.ms-excel";
    //     if (!isJpgOrPng) {
    //         message.error("请上传excel");
    //         return false
    //     }
    //     return true;
    // };
};

WatermarkManage.defaultProps = {};
WatermarkManage.propTypes = {};